import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from '@wix/document-services-types';

const DISABLED_DROP_OPACITY = 0.7;

export const createDraggedComponentOpacityHandler = (
  editorAPI: EditorAPI,
  selectedComp: CompRef[],
) => {
  let previousShouldIndicate: null | boolean = null;

  return (shouldIndicate: boolean) => {
    if (previousShouldIndicate === shouldIndicate) return;

    if (shouldIndicate) {
      editorAPI.dsActions.renderPlugins.setCompsToShowWithOpacity(
        selectedComp.map((comp) => comp.id),
        DISABLED_DROP_OPACITY,
      );
    } else {
      editorAPI.dsActions.renderPlugins.setCompsToShowWithOpacity([]);
    }

    previousShouldIndicate = shouldIndicate;
  };
};
